module.exports = __webpack_public_path__ + "media/Components/Logos/icon-image-4bc712f789aac29d24c4a70721ec355e.svg";